"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkTheme = exports.lightTheme = void 0;
var breakpoints_1 = require("./breakpoints");
var colors_1 = require("./colors");
var variants_1 = require("./variants");
var Mode;
(function (Mode) {
    Mode["LIGHT"] = "LIGHT";
    Mode["DARK"] = "DARK";
})(Mode || (Mode = {}));
// https://confluence.faradayfuture.com/display/FW/FF.com+Design+System
exports.lightTheme = __assign({ 
    // allow Text component to handle html
    allowHtmlText: false, mode: Mode.LIGHT, maxWidth: '1596px', breakpoints: breakpoints_1.breakpoints, breakpointValues: breakpoints_1.breakpointValues, mediaQueries: {
        xs: "@media screen and (min-width: " + breakpoints_1.breakpoints.xs + ")",
        sm: "@media screen and (min-width: " + breakpoints_1.breakpoints.sm + ")",
        md: "@media screen and (min-width: " + breakpoints_1.breakpoints.md + ")",
        lg: "@media screen and (min-width: " + breakpoints_1.breakpoints.lg + ")",
        xl: "@media screen and (min-width: " + breakpoints_1.breakpoints.xl + ")",
        minWidth: function (value) { return "@media screen and (min-width: " + value + ")"; }
    }, space: [0, 4, 8, 16, 32, 64, 128, 256, 512], fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72, 96], fontWeights: {
        light: 300,
        regular: 400,
        medium: 500,
        bold: 700
    }, colors: colors_1.colors, fonts: {
        Roboto: 'Roboto, "Helvetica Neue", Helvetica, "Segoe UI", Arial, freesans, sans-serif'
    }, zIndices: {
        menubar: 1,
        dropdown: 1,
        menubarDrawer: 2,
        tooltip: 10,
        modal: 1000,
        appBar: 1000,
    }, boxShadows: {
        main: "4px 4px 25px " + colors_1.colors.shadow,
        drawer: "8px 0px 20px " + colors_1.colors.shadow,
    } }, variants_1.variants);
exports.darkTheme = __assign(__assign({}, exports.lightTheme), { mode: Mode.DARK, colors: __assign(__assign({}, exports.lightTheme.colors), colors_1.darkColorsV2) });
// helper function to do type check. make sure theme matches the Theme in style system
validate(exports.lightTheme);
validate(exports.darkTheme);
function validate(theme) { } // eslint-disable-line
exports.default = exports.lightTheme;
